import { camelizeKeys } from 'humps';
import { asyncAttempt, standartPost } from '@namespace/helpers';

const ENDPOINT_URL = '/service/pds/v1/pin/get_data';

export const parseCnp = async (value) => {
  const [, response] = await asyncAttempt(standartPost, ENDPOINT_URL, {
    type: 'cnp',
    value
  });

  if (response) {
    const parsedResponse = camelizeKeys(response);

    return parsedResponse.data;
  }

  return null;
};
